import { Injectable } from '@angular/core';

import { select, Store, Action } from '@ngrx/store';

import * as ListingsActions from './listings.actions';
import * as ListingsFeature from './listings.reducer';
import * as ListingsSelectors from './listings.selectors';

@Injectable()
export class ListingsFacade {
  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  loaded$ = this.store.pipe(select(ListingsSelectors.getListingsLoaded));
  allListings$ = this.store.pipe(select(ListingsSelectors.getAllListings));
  selectedListings$ = this.store.pipe(select(ListingsSelectors.getSelected));

  constructor(private store: Store) {}

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   */
  init() {
    this.store.dispatch(ListingsActions.init());
  }
}
